// @flow

import Default from './default.svg';

const Flags = {
    Default: {
        Path: Default,
        Alt: 'Default'
    }
};

export default Flags;
